import { useState, useEffect, useCallback } from 'react'
import useRouter from 'utils/useRouter'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'

export const useExameQuimico = (idExameRealizado) => {
  const router = useRouter()
  const exameRealizadoService = useExameRealizadoService()
  
  const [exameRealizado, setExameRealizado] = useState(null)
  const [activeStep, setActiveStep] = useState(0)
  const [processandoAlteracaoRespostas, setProcessandoAlteracaoRespostas] = useState(false)

  const fetchExameRealizado = useCallback(async () => {
    if (idExameRealizado) {
      try {
        const response = await exameRealizadoService.listarExameRealizadoDetalhadoAsync(idExameRealizado)
        setExameRealizado(response)
      } catch (error) {
        console.error('Error fetching exame realizado:', error)
      }
    }
  }, [idExameRealizado])

  const handleEtapaAnterior = useCallback(() => {
    if (activeStep === 0) return
    setActiveStep(activeStep - 1)
  }, [activeStep])

  const handleProximaEtapa = useCallback(async () => {
    if (activeStep === 1) {
      try {
        await exameRealizadoService.gerarDocumento(idExameRealizado, setProcessandoAlteracaoRespostas)
        router.history.push({
          pathname: `/casos/caso/solicitacao/exameSolicitado/editorExameRealizado/${idExameRealizado}`,
          state: { IgnoneUploadImagem: true },
        })
      } catch (error) {
        console.error('Error generating document:', error)
      }
    } else {
      setActiveStep(activeStep + 1)
    }
  }, [activeStep, idExameRealizado])

  const handleVoltar = useCallback(() => {
    router.history.goBack()
  }, [])

  useEffect(() => {
    fetchExameRealizado()
  }, [fetchExameRealizado])

  return {
    exameRealizado,
    activeStep,
    processandoAlteracaoRespostas,
    handleEtapaAnterior,
    handleProximaEtapa,
    handleVoltar,
  }
}
